import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

export const convertImageToDataString = createAsyncThunk(
    'util/image/convert_file_to_data_string',
    async ({image}, thunkAPI) => {
        return new Promise((resolve, reject) => {

            if (image) {
                const reader = new FileReader();

                reader.readAsDataURL(image);

                reader.onload = e => {
                    resolve({
                            image: e.target.result,
                            file: image
                        }
                    )
                }

                reader.onerror = e => {
                    reject()
                }
            } else resolve(
                {
                    image: null,
                    file: null
                }
            )

        })
    }
)

const imageSlice = createSlice({
    name: 'util/image',
    initialState: {
        image: null,
        file: null
    },
    extraReducers: builder => {
        builder.addCase(convertImageToDataString.fulfilled, (state, action) => {
            state.image = action.payload.image
            state.file = action.payload.file
        })
    }
})

export default imageSlice.reducer;

export const selectImageUtil = state => state.image